import Metadata from './Metadata';

export default Metadata;
export { Metadata };
